"use strict";
export default React.createClass({
  propTypes: {
    recipients: React.PropTypes.array.isRequired
  },
  getInitialState: function() {
    return {
      bouncedEmails: []
    };
  },
  componentDidMount: function() {
    this.fetchBounces(this.props.recipients);
  },
  render: function() {
    if (_.isEmpty(this.bouncedEmails())) {
      return null;
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, "We were previously unable to send to ", /* @__PURE__ */ React.createElement("strong", null, this.emails()), "... should we try again? ", this.ignoreLink(), ".");
    }
  },
  bouncedEmails: function() {
    return _.intersection(this.props.recipients, this.state.bouncedEmails);
  },
  emails: function() {
    return _.str.toSentenceSerial(this.bouncedEmails());
  },
  ignoreLink: function() {
    return /* @__PURE__ */ React.createElement("a", { onClick: this.ignoreBounces }, "Yes, please");
  },
  setBouncedEmails: function(bounces) {
    const emails = _.map(bounces, "email");
    this.setState({ bouncedEmails: emails });
  },
  fetchBounces: function(recipients) {
    jQuery.get({
      url: "/api/bouncing_email_addresses",
      data: { emails: recipients },
      success: this.setBouncedEmails
    });
  },
  ignoreBounces: function() {
    jQuery.ajax({
      url: "/api/bouncing_email_addresses",
      method: "DELETE",
      data: { emails: this.bouncedEmails() },
      success: this.setBouncedEmails
    });
  }
});
